import { useEffect, useState } from "react";

const STORAGE_KEY = "pme-hr-device-id";

function generateFingerprint(): string {
  // Soft binding only — if the user clears storage, an admin rebinds.
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers.
  return `dev-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}

export function useDeviceFingerprint(): string {
  const [value, setValue] = useState<string>(() => {
    if (typeof window === "undefined") return "";
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const fresh = generateFingerprint();
    window.localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  });

  useEffect(() => {
    if (!value && typeof window !== "undefined") {
      const fresh = generateFingerprint();
      window.localStorage.setItem(STORAGE_KEY, fresh);
      setValue(fresh);
    }
  }, [value]);

  return value;
}
